module.exports = __webpack_public_path__ + "img/grey_046.9b9977f0.png";